import { render } from "./UiTextArea.vue?vue&type=template&id=59c52d3e&ts=true"
import script from "./UiTextArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiTextArea.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiTextArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59c52d3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59c52d3e', __exports__)) {
    api.reload('59c52d3e', __exports__)
  }
  
  module.hot.accept("./UiTextArea.vue?vue&type=template&id=59c52d3e&ts=true", () => {
    api.rerender('59c52d3e', render)
  })

}


export default __exports__